import { AxiosResponse } from "axios";
import { Base } from "./bases/base.service";

export default class AuthService {
  public getSelf(): Promise<AxiosResponse<any>> {
    return Base().get("auth/self");
  }
  public register(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("auth/register", params);
  }
  public login(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("auth/login", params);
  }
  public sendForgotPassword(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("auth/request", params);
  }
  public changeForgotPassword(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("auth/reset", params);
  }
  public editProfile(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("auth/edit", params);
  }
  public sendLoginOtp(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("auth/otp/login/send", params);
  }
  public validateLoginOtp(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("auth/otp/login/validate", params);
  }
  public sendRegisterOtp(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("auth/otp/register/send", params);
  }
  public validateRegisterOtp(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("auth/otp/register/validate", params);
  }
  public loginWithGoogle(params: any = {}): Promise<AxiosResponse<any>> {
    return Base().post("oauth/login", params);
  }
}
